module.exports = __webpack_public_path__ + "img/kingscourt-min.0eb4b84b.png";